<div *ngIf="(this.activeChannelConfiguration$ | async)?.text" class="ap-margin-top-2 ap-margin-bottom-2 ap-display-block">
    <ap-notification status="warning">
        {{ (this.activeChannelConfiguration$ | async)?.text }}
    </ap-notification>
</div>

<h1 class="ap-margin-bottom-6 ap-margin-top-6 ap-display-block">
    <ap-content key="kantoor-sign.header.text"></ap-content>
</h1>
<ap-notification *ngIf="signError" status="error">
    <ap-content key="kantoor-sign.error"></ap-content>
</ap-notification>

<ap-sign
    [submitText]="'kantoor-sign.login-button.text' | apContent"
    [actionId]="actionId"
    [showWysiwys]="false"
    [initWithToken]="token"
    [allowDeselect]="false"
    [showLostCredentials]="false"
    (done)="complete()"
    (error)="error()"
    (retry)="setActionId()"
></ap-sign>

<ap-keyword-explanation *ngIf="showProblemsLogin()" [term]="'kantoor-sign.problemen-inloggen' | apContent">
    <ap-grid-row>
        <ap-grid-col>
            <ap-icon-button-link
                (click)="downloadPdf(stappenplanType)"
                iconName="arrow-right"
                (keydown.enter)="downloadPdf(stappenplanType)"
            >
                <ap-content key="kantoor-sign.stappenplan"></ap-content>
            </ap-icon-button-link>
        </ap-grid-col>
    </ap-grid-row>
    <ap-grid-row>
        <ap-grid-col>
            <ap-icon-button-link (click)="downloadPdf(qAndAType)" iconName="arrow-right" (keydown.enter)="downloadPdf(qAndAType)">
                <ap-content key="kantoor-sign.q-and-a"></ap-content>
            </ap-icon-button-link>
        </ap-grid-col>
    </ap-grid-row>
</ap-keyword-explanation>
